import { db } from "../firebase";
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, query, orderBy, serverTimestamp, onSnapshot, writeBatch } from "firebase/firestore";
import { getUser } from "../utils/sessao";

const SHARED_DATA_EMAILS = ["matriz03d@gmail.com"];

function colPath(name) {
  const user = getUser();
  if (!user?.uid) return name;
  // emails com acesso às coleções raiz (dados compartilhados)
  if (SHARED_DATA_EMAILS.includes(user.email)) return name;
  // demais usuários ficam isolados no próprio espaço
  return `users/${user.uid}/${name}`;
}

async function getSnap(path) {
  try {
    const snap = await getDocs(query(collection(db, path), orderBy("created_at", "desc")));
    return snap.docs;
  } catch {
    const snap = await getDocs(collection(db, path));
    return snap.docs;
  }
}

export async function fbList(col) {
  const docs = await getSnap(colPath(col));
  return docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function fbAdd(col, data) {
  return addDoc(collection(db, colPath(col)), { ...data, created_at: serverTimestamp() });
}

export async function fbUpdate(col, id, data) {
  return updateDoc(doc(db, colPath(col), id), data);
}

// Aplica vários updates de uma vez, atomicamente — evita estado inconsistente
// quando duas escritas separadas (ex.: trocar a posição de dois itens) caem
// em snapshots diferentes no meio do caminho. items: [{ col, id, data }]
export async function fbBatchUpdate(items) {
  const batch = writeBatch(db);
  for (const { col, id, data } of items) {
    batch.update(doc(db, colPath(col), id), data);
  }
  return batch.commit();
}

export async function fbDelete(col, id) {
  return deleteDoc(doc(db, colPath(col), id));
}

// Escuta em tempo real. cb recebe a lista atualizada; retorna a função de unsubscribe.
export function fbWatch(col, cb) {
  try {
    return onSnapshot(
      collection(db, colPath(col)),
      snap => cb(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
      err => console.error("fbWatch", col, err)
    );
  } catch (e) { console.error("fbWatch", col, e); return () => {}; }
}

export { colPath as fbCollectionPath };
